/*
 * edge.js
 *
 * (c) EdgeJS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import { TagContract } from '../types.js'

export const elseTag: TagContract = {
  block: false,
  seekable: false,
  tagName: 'else',

  /**
   * Compiles else block node to Javascript else statement
   */
  compile(_, buffer, token) {
    buffer.writeStatement('} else {', token.filename, -1)
  },
}
